import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { RepresentanteFormInputDisabledModule } from '../../../../pessoa/representante/components/form-input-disabled';
import { ClienteAnaliseMercadoRevisaoStatusBadgeModule } from '../status-badge';

import { ClienteAnaliseMercadoRevisaoFormInfoComponent } from './cliente-analise-mercado-revisao-form-info.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoRevisaoStatusBadgeModule,
        RepresentanteFormInputDisabledModule
    ],
    declarations: [
        ClienteAnaliseMercadoRevisaoFormInfoComponent
    ],
    exports: [
        ClienteAnaliseMercadoRevisaoFormInfoComponent
    ]
})
export class ClienteAnaliseMercadoRevisaoFormInfoModule { }
